import Paper from '@mui/material/Paper';
import React, { useEffect, useState } from 'react';
import { Link } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { cleanFilterItem } from '@mui/x-data-grid/hooks/features/filter/gridFilterUtils';
import { useSearchParams } from 'react-router-dom';

export default function TableTopicsData({
  topicsData,
  onTopicClick,
  columns,
  noRowsLabel = 'No topics available',
}) {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });

  const { page, pageSize } = paginationModel;

  console.warn({ topicsData });
  // Prepare rows with continuous serial numbers (S.No)

  const [rows, setrows] = useState([]);
  useEffect(() => {
    const rows = Array.isArray(topicsData) ? topicsData : [];
    setrows(rows);
  }, [topicsData]);

  const rowsWithSno = rows
    .slice(page * pageSize, page * pageSize + pageSize) // get current page slice
    .map((row, index) => ({
      ...row,
      id: row.id || index + page * pageSize, // Ensure unique id
      sno: page * pageSize + index + 1,
    }));

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden', boxShadow: 'none' }}>
      <div style={{ minWidth: '1200px' }}>
        <DataGrid
          rows={rowsWithSno}
          getRowHeight={() => 'auto'} // Enables dynamic row height
          columns={columns}
          onRowClick={(params) => onTopicClick(params.row.topicName)} // handle row click
          pagination
          localeText={{
            noRowsLabel, // 👈 custom message here
          }}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[20, 50, 100]}
          autoHeight
          sx={{
            'fontFamily': 'Nunito Sans, sans-serif',
            'fontSize': '14px',
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#ebebeb',
              color: '#000',
              fontWeight: 'bold',
              fontSize: '14px',
              padding: '6px',
            },
            '& .MuiDataGrid-cell': {
              padding: '6px',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5f5f5',
            },
          }}
        />
      </div>
    </Paper>
  );
}
